'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AuthService = exports.AuthService = function AuthService($q, $timeout, $localStorage, $http) {
  'ngInject';

  var actions = {};

  actions.login = function (username, password) {
    if (username == 'admin' && password == 'ChangeMe') {
      $localStorage.user = {
        login: 'admin'
      };
      return true;
    } else {
      return false;
    }
    //return $http({
    //  method: 'post',
    //  url: `${API_URL}/auth/login`,
    //  data: {
    //    login: username,
    //    password: password
    //  }
    //}).then(response => {
    //  return response.data.token;
    //});
  };

  actions.logout = function () {
    //const defer = $q.defer();
    //delete $localStorage.token;
    delete $localStorage.user;
    //defer.resolve();
    //return defer.promise;
  };

  actions.me = function () {
    //return $http({
    //  method: 'get',
    //  url: `${API_URL}/users/me`
    //}).then(response => {
    //  return response.data;
    //});
  };

  actions.getCurrentUser = function () {
    return $localStorage.user;
    //const defer = $q.defer();
    //defer.resolve($localStorage.user);
    //return defer.promise;
  };

  actions.setCurrentUser = function (data) {
    //const defer = $q.defer();
    //if (!data) {
    //  return defer.reject('Current User is empty');
    //}
    //$localStorage.user = data;
    //defer.resolve();
    //return defer.promise;
  };

  actions.setToken = function (token) {
    //const defer = $q.defer();
    //if (!token) {
    //  return defer.reject('Token is empty');
    //}
    //$localStorage.token = token;
    //defer.resolve();
    //return defer.promise;
  };

  actions.getToken = function () {
    //return $localStorage.token;
  };

  return actions;
};

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/common/auth/auth.service.js
 **/